import {
  APPROVAL_STATUS_LABELS,
  APPROVAL_STEP_STATUS_LABELS,
} from "../../ProjectsV2/ProjectFinance/Agreements/agreementsListHelpers";
import { resolvePerformerDisplayName } from "../../ProjectsV2/ProjectFinance/AgreementsV2/agreementsHelpers";

export { APPROVAL_STATUS_LABELS, APPROVAL_STEP_STATUS_LABELS };

export const resolveAgreementCounterpartyName = (agreement, entry = {}) => {
  const counterpartyName =
    entry?.counterparty_name ??
    agreement?.counterparty_name ??
    agreement?.counterparty_summary?.display_name ??
    agreement?.counterparty_summary?.full_name ??
    null;

  if (counterpartyName) return counterpartyName;

  return resolvePerformerDisplayName(agreement) ?? null;
};

export const normalizeMyAgreementApprovalEntry = (entry, userId) => {
  const approval = entry?.approval ?? entry;
  if (!approval?.id) return null;

  const agreement = entry?.agreement ?? approval?.agreement ?? {};
  const steps = Array.isArray(approval.steps) ? approval.steps : [];
  const myStep =
    steps.find(
      (step) =>
        step?.approver_id != null &&
        userId != null &&
        String(step.approver_id) === String(userId),
    ) ?? null;

  return {
    id: approval.id,
    agreementId: approval.agreement_id ?? agreement?.id ?? entry?.agreement_id,
    approval,
    agreement,
    projectId:
      entry?.project_id ??
      agreement?.project_id ??
      approval?.project_id ??
      null,
    projectName:
      entry?.project_name ??
      agreement?.project_name ??
      approval?.project_name ??
      null,
    initiatorName:
      entry?.initiator_name ??
      approval?.initiator_name ??
      entry?.creator_name ??
      null,
    counterpartyName: resolveAgreementCounterpartyName(agreement, entry),
    agreementNumber:
      agreement?.number ?? entry?.agreement_number ?? approval?.agreement_number,
    price: agreement?.price ?? entry?.price ?? approval?.price ?? null,
    createdAt: approval.created_at ?? entry?.created_at ?? null,
    status: approval.status,
    myStep,
    steps,
  };
};

export const getStepStatusText = (status) =>
  APPROVAL_STEP_STATUS_LABELS[status] ??
  (status === "pending"
    ? "На рассмотрении"
    : status === "approved" || status === "signed"
      ? "Согласован"
      : status === "rejected"
        ? "Отклонён"
        : status ?? "—");

export const getApprovalStatusText = (status) =>
  APPROVAL_STATUS_LABELS[status] ?? status ?? "—";

export const formatAgreementNumber = (num) => {
  if (num == null) return "—";
  return `№${num}`;
};
